export const categoriesData = [
  {
    id: 1,
    name: 'Electronics',
    description: 'Electronic devices and gadgets',
    image: 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=100&h=100&fit=crop',
    productCount: 45,
    status: 'Active',
    createdAt: '2024-01-15',
  },
  {
    id: 2,
    name: 'Clothing',
    description: 'Fashion and apparel items',
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=100&h=100&fit=crop',
    productCount: 32,
    status: 'Active',
    createdAt: '2024-01-10',
  },
  {
    id: 3,
    name: 'Home & Garden',
    description: 'Home improvement and garden supplies',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=100&h=100&fit=crop',
    productCount: 28,
    status: 'Active',
    createdAt: '2024-01-08',
  },
  {
    id: 4,
    name: 'Sports',
    description: 'Sports equipment and accessories',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=100&h=100&fit=crop',
    productCount: 15,
    status: 'Inactive',
    createdAt: '2024-01-05',
  },
  {
    id: 5,
    name: 'Books',
    description: 'Books and educational materials',
    image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=100&h=100&fit=crop',
    productCount: 67,
    status: 'Active',
    createdAt: '2024-01-03',
  },
  {
    id: 6,
    name: 'Beauty',
    description: 'Beauty and personal care products',
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=100&h=100&fit=crop',
    productCount: 23,
    status: 'Active',
    createdAt: '2024-01-01',
  },
];